export const getAvailableOrganizations = (state) => {
    return state.organization_switcher?.availableOrganizations || [];
};

export const getCurrentOrganizationId = (state) => {
    return state.organization_switcher?.currentOrganizationId || null;
};

export const getCurrentOrganization = (state) => {
    const currentId = state.organization_switcher?.currentOrganizationId;
    const organizations = state.organization_switcher?.availableOrganizations || [];
    return organizations.find(org => org.org_id === currentId);
};

export const getIsCurrentOrganizationPersonal = (state) => {
    const current = getCurrentOrganization(state);
    if (!current) {
        return false;
    }
    return current.organization.type === 'PERSONAL';
};

export const getIsLoadingOrganizations = (state) => {
    return state.organization_switcher?.isLoading || false;
};

// Helper to get the effective organization ID that should be used for API calls
export const getEffectiveOrganizationId = (state) => {
    const currentOrgId = state.organization_switcher?.currentOrganizationId;
    
    if (currentOrgId) {
        return currentOrgId;
    }
    
    // Fallback to localStorage if Redux state is not set yet
    const storedOrgId = localStorage.getItem('selectedOrganizationId');
    if (storedOrgId) {
        return storedOrgId;
    }
    
    // Last fallback - we'll let the backend determine the org from roles
    return null;
};